// Owner helpers for snapshot nodes. An unowned (neutral) city has no COwner in the sim, but the
// snapshot still emits `ownerId: 0` (the human's index) for it and flags `props.neutral: true`.
// Anything that derives ownership from `ownerId` for a CITY must go through these helpers, or a
// neutral village reads as "Player 1" and offers own-city actions.

type Props = Record<string, unknown> | undefined;

/** True for an unowned city node's props. */
export function isNeutralProps(props: Props): boolean {
  return props?.neutral === true;
}

/** The city's owner index, or `undefined` for a neutral city / missing owner. */
export function cityOwnerId(props: Props): number | undefined {
  if (isNeutralProps(props)) return undefined;
  return props?.ownerId as number | undefined;
}

/** Is this city owned by `localPlayerIndex` (never true for a neutral city)? */
export function isOwnCityProps(props: Props, localPlayerIndex: number): boolean {
  return cityOwnerId(props) === localPlayerIndex;
}
